import { render, staticRenderFns } from "./WorkGroupDetailCardstack.vue?vue&type=template&id=03f52eeb"
import script from "./WorkGroupDetailCardstack.vue?vue&type=script&lang=js"
export * from "./WorkGroupDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports